import Vue from "vue";
import Vuex from "vuex";
import history from "./modules/history";
import seo from "./modules/seo";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navIdx: undefined,
  },
  getters: {},
  mutations: {
    setSelectedNav(state, id) {
      state.navIdx = id;
    },
  },
  actions: {},
  modules: {
    history,
    seo,
  },
});
